import { SelectableDealOption } from './deal-types'

export function isFsdGrowthModelValue(autopilotSelectableValue: SelectableDealOption['selectedValue']) {
    const labelId = autopilotSelectableValue.labelId.trim()
    return labelId.includes('full_self_driving') && labelId.endsWith('model')
}
